if (!customElements.get('lester-home-feed')) {
  customElements.define('lester-home-feed', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.grid = this.querySelector('[data-feed-grid]');
      this.status = this.querySelector('[data-feed-status]');
      this.more = this.querySelector('[data-feed-more]');
      this.sentinel = this.querySelector('[data-feed-sentinel]');
      this.next = this.dataset.url;
      this.seen = new Set();
      this.grid.replaceChildren();
      this.more.addEventListener('click', () => this.load());
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.load();
        }, { rootMargin: '650px 0px' });
        this.observer.observe(this.sentinel);
      }
      this.load();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
    async load() {
      if (this.busy || !this.next) return;
      this.busy = true;
      this.observer?.unobserve(this.sentinel);
      this.more.disabled = true;
      this.status.textContent = 'Cargando obras…';
      this.grid.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      try {
        const url = new URL(this.next, location.origin);
        url.searchParams.set('sort_by', 'price-descending');
        url.searchParams.set('section_id', 'lester-home-feed');
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('No se pudo cargar la colección');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = doc.querySelector('[data-lj-feed-page]');
        if (!page) throw new Error('Respuesta de colección incompleta');
        page.querySelectorAll('[data-lj-feed-items] > .lj-art').forEach(card => {
          const href = card.querySelector('a')?.getAttribute('href');
          if (!href || this.seen.has(href)) return;
          this.seen.add(href);
          this.grid.append(card);
        });
        this.next = page.dataset.next || null;
        this.more.hidden = !this.next;
        this.status.textContent = this.next
          ? `${this.seen.size} de ${page.dataset.total} obras`
          : `Has descubierto las ${this.seen.size} obras de la colección.`;
        if (!this.next) this.observer?.disconnect();
        else this.observer?.observe(this.sentinel);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.status.textContent = 'No se han podido cargar las obras. Puedes intentarlo de nuevo.';
        this.more.textContent = 'Volver a intentar';
      } finally {
        this.busy = false;
        this.more.disabled = false;
        this.grid.removeAttribute('aria-busy');
      }
    }
  });
}
